import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import home from './home'
import common from './common'
import houseAuditDetail from './houseAuditDetail'
import houseAuditList from './houseAuditList'
import demo from './demo'
import houseDetail from './houseDetail'
import personMainPage from './personMainPage'
import personIdentifiedPage from './personIdentifiedPage'
import personMsgPage from './personMsgPage'
import releaseRentalHousing from './releaseRentalHousing'
import propertyVerificate from './propertyVerificate'
import recordContract from './recordContracts'
import personPropertyCheck from './personPropertyCheck'
import editHouseInfo from './editHouseInfo'
import editContract from './editContracts'
import viewContract from './viewContract'
import myContract from './myContract'
import rentHouseSource from './rentHouseSource'
import searchRentInfo from './searchRentInfo'
import personHousePage from './personHousePage'
import releaseSearchRent from './releaseSearchRent'
import editSearchRent from './editSearchRent'
import personSearchRent from './personSearchRent'
import verificateQuery from './verificateQuery'


export default combineReducers({
    router: routerReducer,
    home,
    common,
    houseAuditDetail,
    houseAuditList,
    houseDetail,
    personMainPage,
    demo,
    releaseRentalHousing,
    propertyVerificate,
    recordContract,
    personPropertyCheck,
    personIdentifiedPage,
    personMsgPage,
    editHouseInfo,
    editContract,
    viewContract,
    myContract,
    rentHouseSource,
    searchRentInfo,
    personHousePage,
    releaseSearchRent,
    editSearchRent,
    personSearchRent,
    verificateQuery
})


// WEBPACK FOOTER //
// ./src/modules/index.js